/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import {EnhancedAuditEvent} from '../ConfigurationList'
import {getSimpleCellItemComponent} from './getSimpleCellItemComponent'

export interface UserSearchHeaderProps {
  userId?: string
  onUserIdChange?: (newQuery: string) => void
}

export const UserRow = getSimpleCellItemComponent<EnhancedAuditEvent>((item) =>
  item.userName ? item.userName : item.userId
)
